import React from 'react';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

/**
 * A MUI Button that shows a centered CircularProgress overlay when `loading` is true.
 * Automatically disabled while loading.
 */
export default function LoadingOverlayButton({ loading, disabled, children, style, ...props }) {
  return (
    <Button disabled={disabled || loading} style={{ position: 'relative', ...style }} {...props}>
      {children}
      {loading && (
        <span style={{
          position: 'absolute',
          top: 0, left: 0, right: 0, bottom: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'rgba(255, 255, 255, 0.5)',
          borderRadius: 'inherit',
        }}>
          <CircularProgress size={22} />
        </span>
      )}
    </Button>
  );
}
